// extracted by mini-css-extract-plugin
export default {"root":"IsO8j","label":"daVgJ"};